



















import { BaseStepForm } from '@/components/forms/onboarding/BaseStepForm';
import { IODEquipmentForm } from '@/model';
import { IDatastoreResource } from '@homeserve/vue-api-plugin';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class EquipmentForm extends BaseStepForm<IODEquipmentForm> {
  @State('equipment', { namespace: 'api/trader/trader' })
  public equipment!: IDatastoreResource[];

  public readonly formScope = 'equipmentForm';
}
